import { render, staticRenderFns } from "./Top10HorizontalTitleListGraphql.vue?vue&type=template&id=b0fac6f4&scoped=true"
import script from "./Top10HorizontalTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
export * from "./Top10HorizontalTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Top10HorizontalTitleListGraphql.vue?vue&type=style&index=0&id=b0fac6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fac6f4",
  null
  
)

export default component.exports